import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { AnswerLookupViewModel, MonitoringSectionViewModel } from "../ViewModels/GetMonitoringScorecardResponse";
import MonitoringQuestion from "./MonitoringQuestion";

const styles = {
    question: {
        '&:hover': {
            backgroundColor: '#6767674f'
        }
    }
}

interface IProps {
    callRefId: string
    section: MonitoringSectionViewModel;
    readOnly: boolean;
    updateParent: () => void;
    answers: AnswerLookupViewModel[];
    completeId: number;
    feedbackView?: string
}

export default function MonitoringSection(props: IProps) {

    const classes = styles;

    return (
        <Grid container justifyContent="space-between">
            {props.section.description &&
                <Grid size={12}>
                    <Typography textAlign="center" variant="subtitle2"><i>{props.section.description} test</i> </Typography>
                </Grid>
            }
            {props.section.questions.map((question, index) =>
                <Grid size={12} key={question.id} sx={classes.question}>
                    {<MonitoringQuestion
                        question={question}
                        readOnly={props.readOnly}
                        updateParent={props.updateParent}
                        grey={index % 2 !== 0}
                        callRefId={props.callRefId}
                        answers={props.answers}
                        completeId={props.completeId}
                        feedbackView={props.feedbackView}
                    />}
                </Grid>
            )}
        </Grid >
    );
}